import SummaryBarChartStyle from './SummaryBarChart.module.scss';
import * as d3 from 'd3';
import * as React from 'react';
import { observer } from 'mobx-react';
import { SvgBar } from './../SvgBar/SvgBar';
import { SvgAxis } from './../SvgAxis/SvgAxis';
import { RectangleWithGradient } from './../RectangleWithGradient/RectangleWithGradient';
import { AverageMarker } from './../AverageMarker/AverageMarker';
import { ISummaryBarChart } from './ISummaryBarChart';
import { TargetsHelper } from 'MeasurementsCalculations';
import { IReportMeasurementGroup } from 'Data';

@observer
export class SummaryBarChart extends React.Component<ISummaryBarChart> {
  private width = 1140;
  private height = 500;

  constructor(props: ISummaryBarChart) {
    super(props, undefined);

    if (this.props.width && this.props.width > 0) this.width = this.props.width;
    //if (this.props.showScrollbar == false) {
    //    this.height = this.height - 50;
    //}

    if (this.props.height && this.props.height > 0) this.height = this.props.height;
  }

  render() {
    if (
      !this.props.testResult ||
      !this.props.testResult.statistics ||
      !this.props.testResult.statistics.avgScore
    )
      return <div></div>;
    const margins = { top: 50, bottom: 50, left: 126, right: 89 };

    const numberOfBars = this.props.measurementGroups.length;
    const widthOfBar = 20;
    const domainWidth = numberOfBars <= 10 ? numberOfBars * (72 + 20) : numberOfBars * (68 + 20);
    const heightWithoutMargins = this.height - margins.top - margins.bottom;
    const widthWithoutMargins = this.width - margins.left - margins.right;
    let minScore = 40;
    for (let i = 0; i < this.props.measurementGroups.length; i++) {
      const mg = this.props.measurementGroups && this.props.measurementGroups[i];
      if (mg && mg.averageScore && mg.averageScore < minScore) {
        minScore = Math.floor(+mg.averageScore / 10) * 10;
      }
    }
    const yScale = d3.scale
      .linear()
      //.domain([0, d3.max(data)])
      .domain([minScore, 100])
      .range([heightWithoutMargins + margins.bottom, margins.top]);

    const xScale = d3.scale
      .ordinal()
      .domain(
        this.props.measurementGroups
          .filter(x => x.target !== null)
          .map(
            (group, index) =>
              TargetsHelper.targetInUnits(group, this.props.selectedUnit) + ';' + index
          )
      )
      .rangeRoundBands([0, domainWidth]);

    const yPos = yScale(this.props.testResult.statistics.avgScore);
    const unit = this.props.testResult.definition.inYards ? 'Yds' : 'm';

    return (
      <div className={`${SummaryBarChartStyle.SummaryBarChart} row`}>
        <svg width={this.width} height={this.height + 30}>
          <RectangleWithGradient
            height={50}
            width={widthWithoutMargins}
            x={margins.left}
            y={this.height - margins.bottom - margins.top}
            id={this.props.idForGradient}
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
            spreadMethod="pad"
            offset1="0%"
            stopColor1="#E8E8E8"
            offset2="90%"
            stopColor2="#fff"
          />

          <text
            className={SummaryBarChartStyle.scoresText}
            x={margins.left - 75}
            y={margins.top - 20}
          >
            Score
          </text>
          <SvgAxis
            scale={yScale}
            tickSize={widthWithoutMargins}
            orient="left"
            translate={`translate(${margins.left}, 0)`}
          />
        </svg>
        <div
          style={{
            width: widthWithoutMargins + 7,
            overflow: 'scroll',
            position: 'absolute',
            top: 0,
            left: margins.left,
          }}
        >
          <svg width={domainWidth} height={this.height}>
            {this.props.measurementGroups.map((group: IReportMeasurementGroup, i) => {
              const x =
                xScale(TargetsHelper.targetInUnits(group, this.props.selectedUnit) + ';' + i) + 34;
              const y = yScale(group.averageScore ?? 1);
              return (
                <SvgBar
                  height={yScale(minScore) - y}
                  width={widthOfBar}
                  x={x}
                  key={group.id}
                  y={y}
                  color={group.color}
                  scores={group.averageScore}
                />
              );
            })}
            <SvgAxis
              scale={xScale}
              tickSize={1}
              orient="bottom"
              translate={`translate(0, ${heightWithoutMargins + margins.bottom})`}
            />
          </svg>
        </div>
        <div style={{ position: 'absolute', top: 0 }}>
          <svg width={this.width} height={this.height}>
            <text
              className={SummaryBarChartStyle.targetText}
              x={margins.left + widthWithoutMargins + 34}
              y={yScale(minScore)}
            >
              Target
            </text>
            <text
              className={SummaryBarChartStyle.targetValue}
              x={margins.left + widthWithoutMargins + 34}
              y={yScale(minScore) + 20}
            >
              {unit}
            </text>
            <AverageMarker
              averageScore={this.props.testResult.statistics.avgScore}
              x1={margins.left}
              x2={margins.left + widthWithoutMargins}
              y1={yPos}
              y2={yPos}
            />
          </svg>
        </div>
      </div>
    );
  }
}
